export default __webpack_public_path__ + "static/media/loading-logo.e8e8aae1.png";